<template>
  <div id="main-wrapper">
    <workspace-topbar />
    <workspace-menubar />

    <div class="page-wrapper">
      <router-view />
      <workspace-footer />
    </div>
    <BlockUI v-if="showBlockUI" :message="msg" class="blockui">
      <i class="fa fa-cog fa-spin fa-3x fa-fw" />
    </BlockUI>
  </div>
</template>

<script>
import WorkspaceTopbar from './WorkspaceTopbar.vue'
import WorkspaceMenubar from './WorkspaceMenubar.vue'
import WorkspaceFooter from './WorkspaceFooter.vue'
import EventBus from '../../event-bus'

export default {
  name: 'App',
  components: { WorkspaceTopbar, WorkspaceMenubar, WorkspaceFooter },
  data () {
    return {
      msg: 'Please wait',
      showBlockUI: false,
      timeout: null

    }
  },
  mounted () {
    EventBus.$on('showBlockUI', (msg) => {
      this.msg = msg
      this.timeout = setTimeout(() => {
        this.showBlockUI = true
      }, 500)
    })
    EventBus.$on('hideBlockUI', () => {
      this.msg = 'Please wait'
      clearTimeout(this.timeout)
      this.showBlockUI = false
    })
    this.init()
  },
  methods: {

    init () {
      $(function () {
        'use strict'
        $('#main-wrapper').AdminSettings({
          Theme: false, // this can be true or false ( true means dark and false means light ),
          Layout: 'vertical',
          LogoBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          NavbarBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          SidebarType: 'full', // You can change it full / mini-sidebar / iconbar / overlay
          SidebarColor: 'skin5', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
          SidebarPosition: true, // it can be true / false ( true means Fixed and false means absolute )
          HeaderPosition: true, // it can be true / false ( true means Fixed and false means absolute )
          BoxedLayout: false // it can be true / false ( true means Boxed and false means Fluid )
        })
      })

      $(function () {
        'use strict'

        $('.preloader').fadeOut()
        // ==============================================================
        // Theme options
        // ==============================================================
        // ==============================================================
        // sidebar-hover
        // ==============================================================

        $('.left-sidebar').hover(
          function () {
            $('.navbar-header').addClass('expand-logo')
          },
          function () {
            $('.navbar-header').removeClass('expand-logo')
          }
        )
        // this is for close icon when navigation open in mobile view
        $('.nav-toggler').on('click', function () {
          $('#main-wrapper').toggleClass('show-sidebar')
          $('.nav-toggler i').toggleClass('ti-menu')
        })
        $('.nav-lock').on('click', function () {
          $('body').toggleClass('lock-nav')
          $('.nav-lock i').toggleClass('mdi-toggle-switch-off')
          $('body, .page-wrapper').trigger('resize')
        })
        $('.search-box a, .search-box .app-search .srh-btn').on('click', function () {
          $('.app-search').toggle(200)
          $('.app-search input').focus()
        })

        // ==============================================================
        // Right sidebar options
        // ==============================================================
        $(function () {
          $('.service-panel-toggle').on('click', function () {
            $('.customizer').toggleClass('show-service-panel')
          })
          $('.page-wrapper').on('click', function () {
            $('.customizer').removeClass('show-service-panel')
          })
        })
        // ==============================================================
        // This is for the floating labels
        // ==============================================================
        $('.floating-labels .form-control').on('focus blur', function (e) {
          $(this).parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0))
        }).trigger('blur')

        // ==============================================================
        // tooltip
        // ==============================================================
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        // ==============================================================
        // Popover
        // ==============================================================
        $(function () {
          $('[data-toggle="popover"]').popover()
        })

        // ==============================================================
        // Perfact scrollbar
        // ==============================================================
        $('.message-center, .customizer-body, .scrollable').perfectScrollbar({
          wheelPropagation: !0
        })

        /* var ps = new PerfectScrollbar('.message-body');
        var ps = new PerfectScrollbar('.notifications');
        var ps = new PerfectScrollbar('.scroll-sidebar');
        var ps = new PerfectScrollbar('.customizer-body'); */

        // ==============================================================
        // Resize all elements
        // ==============================================================
        $('body, .page-wrapper').trigger('resize')
        $('.page-wrapper').delay(20).show()
        // ==============================================================
        // To do list
        // ==============================================================
        $('.list-task li label').click(function () {
          $(this).toggleClass('task-done')
        })
        // ==============================================================
        // Collapsable cards
        // ==============================================================
        $('a[data-action="collapse"]').on('click', function (e) {
          e.preventDefault()
          $(this).closest('.card').find('[data-action="collapse"] i').toggleClass('ti-minus ti-plus')
          $(this).closest('.card').children('.card-body').collapse('toggle')
        })
        // Toggle fullscreen
        $('a[data-action="expand"]').on('click', function (e) {
          e.preventDefault()
          $(this).closest('.card').find('[data-action="expand"] i').toggleClass('mdi-arrow-expand mdi-arrow-compress')
          $(this).closest('.card').toggleClass('card-fullscreen')
        })
        // Close Card
        $('a[data-action="close"]').on('click', function () {
          $(this).closest('.card').removeClass().slideUp('fast')
        })
        // ==============================================================
        // LThis is for mega menu
        // ==============================================================
        $(document).on('click', '.mega-dropdown', function (e) {
          e.stopPropagation()
        })
        // ==============================================================
        // Last month earning
        // ==============================================================
        var sparklineLogin = function () {
          $('.lastmonth').sparkline([6, 10, 9, 11, 9, 10, 12], {
            type: 'bar',
            height: '35',
            barWidth: '4',
            width: '100%',
            resize: true,
            barSpacing: '8',
            barColor: '#2961ff'
          })
        }
        var sparkResize

        $(window).resize(function () {
          clearTimeout(sparkResize)
          sparkResize = setTimeout(sparklineLogin, 500)
        })
        sparklineLogin()

        // ==============================================================
        // This is for the innerleft sidebar
        // ==============================================================
        $('.show-left-part').on('click', function () {
          $('.left-part').toggleClass('show-panel')
          $('.show-left-part').toggleClass('ti-menu')
        })

        // Disable right click and f12

        $('html').on('contextmenu', function () {
          return false
        })
        $(document).keydown(function (event) {
          if (event.keyCode == 123) { // Prevent F12
            return false
          } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
            return false
          }
        })
      })
    }
  }
}

</script>

<style lang="scss">
.blockui.loading-container {
  .loading {
    background-color: transparent;
    box-shadow: none;
  }
}
</style>
